import { z } from 'zod';
import { DISPOSAL_PURPOSE_SCHEMA } from '@schuettflix/interfaces';
import { AdditionalPropertiesIdSchema } from '../enums/additional-properties-schema-id.ts';
import { AbstractAdditionalProperties } from './abstract-additional-properties.ts';

export const ManualMaterialPropertiesSchemaV1 = z.object({
    ...AbstractAdditionalProperties.shape,
    schemaId: AdditionalPropertiesIdSchema.extract(['MANUAL_MATERIAL_V1']),
});
export type ManualMaterialPropertiesV1 = z.infer<typeof ManualMaterialPropertiesSchemaV1>;

export const ManualMaterialWastePropertiesSchemaV1 = z.object({
    ...AbstractAdditionalProperties.shape,
    schemaId: AdditionalPropertiesIdSchema.extract(['MANUAL_WASTE_MATERIAL_V1']),
    disposalPurpose: DISPOSAL_PURPOSE_SCHEMA.optional(),
});
export type ManualMaterialWastePropertiesV1 = z.infer<typeof ManualMaterialWastePropertiesSchemaV1>;
